import { ITooltip, Tooltip as ReactTooltip } from "react-tooltip"

import "react-tooltip/dist/react-tooltip.css"

export type TooltipProps = Omit<ITooltip, "disableStyleInjection">

export const Tooltip = (rest: TooltipProps) => <ReactTooltip delayShow={500} disableStyleInjection {...rest} />
